module.exports = __webpack_public_path__ + "img/imagecheck.3d975222.jpg";